import React, { useMemo } from 'react';
import { FilterDocument } from 'shared/types/filter-document';
import { GroupByMode } from 'shared/types/sorting-mode';
import { ProvidedTaskFilterList } from 'shared/views/task-filter-list';
import { GroupSettings } from 'shared/views/task-filter-list/types';

import { defaultFilter } from '../../constants';

export type TasksOverviewProps = {
  scrollElement?: React.RefObject<HTMLDivElement>;
  filterDocument: FilterDocument;
  setFilterDocument: React.Dispatch<React.SetStateAction<FilterDocument>>;
};

export const TasksOverview: React.FC<TasksOverviewProps> = ({
  scrollElement,
  filterDocument,
  setFilterDocument,
}) => {
  const onSectionCollapse = (collapsedSections: string[]) => {
    setFilterDocument((prev) => ({
      ...prev,
      collapsedSections,
    }));
  };

  const onReset = () => setFilterDocument(defaultFilter);

  const groupSettings = useMemo<GroupSettings>(
    () => ({
      [GroupByMode.CompletedDate]: {
        showRepeatingAsTodo: true,
      },
    }),
    [],
  );

  return (
    <ProvidedTaskFilterList
      filterDocument={filterDocument}
      defaultFilterDocument={defaultFilter}
      onSectionCollapse={onSectionCollapse}
      scrollElement={scrollElement}
      onReset={onReset}
      customOrder={{}}
      groupSettings={groupSettings}
    />
  );
};
